import { Callout } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as R from 'ramda'
import * as React from 'react'
import { connect } from 'react-redux'
import Avatar from '../../components/Avatar'
import buttonStyles from '../../components/Button/button.scss'
import { Dispatch, RootState } from '../../store'
import paymentStyles from './payment-page.scss'

const cx = classnames.bind({
  ...paymentStyles,
  ...buttonStyles
})

type IProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch> & {
    lecture: ILecture | null;
    speakers: Array<IUser | null>;
    onPaymentSubmit: () => void;
  }

class PaymentPageAside extends React.Component<IProps> {
  public render = () => {
    const {
      payment,
      lecture,
      speakers,
      onPaymentSubmit,
      auth,
      onAuthModalOpen
    } = this.props
    const { checkoutError, checkoutItems, orderErrors, loading } = payment
    return (
      <div className={cx('card', 'card--rounded-4', 'page-Payment__aside')}>
        <div className={cx('')}>
          <div className={cx('payment-form__section')}>
            <h6 className={cx('payment-form__title')}>付款資訊</h6>
            <div className={cx('payment-info')}>
              <h3 className={cx('payment-info__lecture-name')}>
                {lecture ? lecture.title : 'N/A'}
              </h3>
              <div className={cx('payment-info__tags')}>
                {lecture
                  ? lecture.tags.map(tag => (
                      <a key={tag} className={cx('payment-info__tag')}>
                        {tag}
                      </a>
                    ))
                  : null}
              </div>
              {speakers.map((speaker, idx) => (
                <div key={idx} className={cx('payment-info__lecturer')}>
                  <Avatar
                    userId={lecture ? lecture.speakerIds[idx] : undefined}
                  />
                  <div className={cx('name')}>
                    {speaker ? speaker.fullName : 'N/A'}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <hr />
          {checkoutError ? (
            <Callout intent="danger">{checkoutError.message}</Callout>
          ) : null}
          <div className={cx('payment-form__section')}>
            <ul className={cx('payment-cost-list')}>
              {checkoutItems.map((item, idx) => (
                <li key={idx} className={cx('payment-cost-list__item')}>
                  <span>{item.name}</span>
                  <span>NT$ {item.amount}</span>
                </li>
              ))}
            </ul>
          </div>
          <hr />
          <div className={cx('payment-form__section')}>
            <div className={cx('payment-result')}>
              <div className={cx('payment-result__text')}>結帳金額</div>
              <div className={cx('payment-result__cost')}>
                {' '}
                NT$ {R.sum(checkoutItems.map(item => item.amount))}
              </div>
            </div>
            {auth.isAuthenticated ? (
              loading ? (
                <div
                  className={cx(
                    'btn',
                    'btn--primary',
                    'btn--lg',
                    'btn--fluid',
                    'btn--disabled'
                  )}
                >
                  處理中，請稍候
                </div>
              ) : (
                <div
                  className={cx('btn', 'btn--primary', 'btn--lg', 'btn--fluid')}
                  onClick={onPaymentSubmit}
                >
                  前往購買
                </div>
              )
            ) : (
              <div
                className={cx('btn', 'btn--primary', 'btn--lg', 'btn--fluid')}
                onClick={onAuthModalOpen}
              >
                前往購買
              </div>
            )}
            {orderErrors
              ? Object.keys(orderErrors).map(field => (
                  <Callout key={field} intent="danger">
                    {orderErrors[field][0]}
                  </Callout>
                ))
              : null}
          </div>
        </div>
      </div>
    )
  }
}

const mapState = ({ payment, auth }: RootState) => ({
  payment,
  auth
})

const mapDispatch = (dispatch: Dispatch) => ({
  onAuthModalOpen: () => dispatch.auth.openAuthModal()
})

export default connect(
  mapState,
  mapDispatch
)(PaymentPageAside)



// WEBPACK FOOTER //
// ./src/pages/PaymentPage/aside.tsx